import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { faCheck, faSlash, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'cpi-three-state-toggle-switch',
	templateUrl: './three-state-toggle-switch.component.html',
	styleUrl: './three-state-toggle-switch.component.scss',
})
export class ThreeStateToggleSwitchComponent implements OnInit {
	componentUUID: string;

	icons = {
		faTimes: faTimes,
		faSlash: faSlash,
		faCheck: faCheck,
	};

	@Input()
	disableMidState = true;

	@Input()
	setState: -1 | 0 | 1 = 0;

	@Output()
	getState = new EventEmitter();

	ngOnInit(): void {
		this.componentUUID = crypto.randomUUID();
	}

	changeState(newState: -1 | 0 | 1) {
		this.setState = newState;
		this.getState.emit(this.setState);
	}
}
